// Removed legacy VoucherWithStats mapper usage

import type { AssignedVoucherSummary } from '../../../services/vouchers.service';
import type { AssignedVoucher } from '../types/assignedVouchers.types';
import { VoucherSubType } from '../types/assignedVouchers.types';

// mapVoucherWithStatsToAssigned removed as fast endpoint is now used

export function mapVoucherSummaryToAssigned(
  summary: AssignedVoucherSummary,
  customerId: number
): AssignedVoucher {
  return {
    voucherId: summary.VoucherId,
    code: summary.Code ?? null,
    description: summary.Description ?? null,
    status: String(summary.Status ?? ''),
    voucherType: String(summary.VoucherType ?? ''),
    voucherSubType: String(summary.VoucherSubType ?? VoucherSubType.Custom),
    isEnabled: Boolean(summary.IsEnabled),
    startDate: null,
    expiryDate: null,
    customerId,
  };
}
